import type { ProcessStepsModuleProps } from "./renderProps";
import { renderTextWithLineBreaks } from "./text";

export function ProcessStepsModule({
  eyebrow,
  heading,
  body,
  steps,
}: ProcessStepsModuleProps) {
  return (
    <section
      className="cms-section cms-process-steps cms-tone-tint"
      data-cms-module="process-steps"
    >
      <div className="cms-wrap">
        <div className="cms-process-steps__intro">
          <div className="cms-eyebrow-row">
            <span className="cms-eyebrow">
              {renderTextWithLineBreaks(eyebrow || "Process")}
            </span>
          </div>
          {heading ? <h2>{renderTextWithLineBreaks(heading)}</h2> : null}
          {body ? <p>{renderTextWithLineBreaks(body)}</p> : null}
        </div>
        <div className="cms-process-steps__list">
          {steps.map((step, index) => (
            <article
              className="cms-process-steps__item"
              key={step.title || index}
            >
              <div className="cms-process-steps__number">
                {String(index + 1).padStart(2, "0")}
              </div>
              <div>
                {step.title ? <h3>{renderTextWithLineBreaks(step.title)}</h3> : null}
                {step.body ? (
                  <p>{renderTextWithLineBreaks(step.body)}</p>
                ) : null}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
